import React, { useEffect, useState } from 'react'
import { Accordion, Alert, Col, Form, FormControl, Row } from 'react-bootstrap'
import CardOption from '../CardOption'
import DynamicAccordionItem from './DynamicAccordionItem'

const DynamicImageSelect = (props) => {


   const [flashesContainerClass, setFlashesContainerClass] = useState('')
   const {
      optionCategories,
      defaultOpen,
      formState,
      setFormState,
      materialId,
      basketState,
      setBasketState,
      step,
      activeIndex,
      listData,
      modelLoaded
   } = props

   const { pleatToTheStripe, flashesMatchKilt, kiltTartan } = formState

   const accordionHeader = (props) => {
      return <h4 className='text-dark'>{props.text}</h4>
   }


   useEffect(() => {
      if (materialId === 'flashes' && flashesMatchKilt) {
         setFlashesContainerClass('opacity-25 pe-none')
      } else {
         setFlashesContainerClass('')
      }
   }, [materialId, flashesMatchKilt])


   const renderCardOptions = (options) => {
      return options.map(option => {
         return <CardOption
            key={`${option.optionName}- ${option.materialId}`}
            step={step}
            basketState={basketState}
            setBasketState={setBasketState}
            option={option}
            formState={formState}
            setFormState={setFormState}
            pleatToTheStripe={pleatToTheStripe}
            flashesMatchKilt={flashesMatchKilt}
            kiltTartan={kiltTartan}
            selected={option.optionValue === formState[option.optionName]}
         />
      })
   }

   const renderErrorInfo = (optionCategories) => {

      return Object.values(optionCategories).map((optionCat, idx) => {
         const { optionName, isRequired } = optionCat
         if (isRequired) {
            return (
               <Form.Group key={'form-' + optionCat.optionName} as={Col} xs={12} >
                  <FormControl className='d-none' name={optionName} type='text' value={formState[optionName]} required readOnly />
                  <Form.Control.Feedback type="invalid" className='mb-3'>
                     <Alert variant='danger'>
                        {isRequired.errorMessage}
                     </Alert>
                  </Form.Control.Feedback>
               </Form.Group>
            )
         }
         return null
      })
   }

   const renderAccordionItems = () => {

      return Object.values(optionCategories).map((optionCat, idx) => {
         const { options } = optionCat
         if (optionCat.dynamicOptions) {
            return (
               <DynamicAccordionItem
                  key={'accordion-' + optionCat.optionName}
                  optionCat={optionCat}
                  accordionHeader={accordionHeader}
                  idx={idx}
                  flashesContainerClass={flashesContainerClass}
                  step={step}
                  activeIndex={activeIndex}
                  listData={listData}
                  formState={formState}
                  setFormState={setFormState}
                  basketState={basketState}
                  setBasketState={setBasketState}
                  modelLoaded={modelLoaded}
               />
            )

         } else {
            return (
               <Accordion.Item key={'accordion-' + optionCat.optionName} eventKey={idx} className={`${flashesContainerClass} border-0 rouded-0`} >
                  <Accordion.Header as={accordionHeader} className='border-0 rounded-0 bg-white' text={optionCat.title}>{optionCat.title}</Accordion.Header>
                  <Accordion.Body className='px-0'>
                     <Row xs={4} lg={5} className="g-2" >
                        {renderCardOptions(options)}
                     </Row>
                  </Accordion.Body>
               </Accordion.Item>
            )
         }
      }
      )
   }

   return (
      <>
         {renderErrorInfo(optionCategories)}

         <Accordion defaultActiveKey={defaultOpen} alwaysOpen={true} className='border-0 rouded-0'>
            {renderAccordionItems()}
         </Accordion>
      </>
   )
}
export default DynamicImageSelect